<template>
  <v-select
    label="Bill Rate Type"
    :items="billRateTypesList"
    v-model="billRateTypeValue"
    item-text="billRateType"
    item-value="id"
    :rules="[requiredCheck()]"
    :readonly="readonly"
    :disabled='disabled'
    :clearable="clearable ? clearable : false"
    outlined
    :dense="dense ? dense : false"
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'isRequired',
    'billRateType',
    'disabled',
    'clearable',
    'readonly',
    'dense'
  ],
  computed: {
    ...mapFields('billRateTypes', [
      'billRateTypesList'
    ]),
    billRateTypeValue: {
      get () {
        return this.billRateType
      },
      set (newValue) {
        this.$emit('billRateTypeChangeHandler', newValue)
      }
    }
  },
  created () {
    this.getBillRateTypes()
  },
  methods: {
    ...mapActions('billRateTypes', [
      'getBillRateTypes'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Bill Rate Type')
    }
  }
}
</script>
